


















































import { Component, Vue } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import dayjs from 'dayjs'
import { Route } from 'vue-router'
import store from '@/store'

@Component({
  components: {
    Loading: () => import('@/components/common/loadings/Index.vue')
  }
})
export default class LabotestImportConfirm extends Vue {
  $store!: ExStore
  dayjs = dayjs
  errorMessage = ''
  isSuccessCreate = false
  pendingImportLabotest = false

  get labotests() {
    return this.$store.getters['labotest/labotests']
  }

  get ignoreCount() {
    return this.$store.getters['labotest/ignoreCount']
  }

  get sessionData(): string {
    return this.$store.getters['user/sessionData']('labotest') || ''
  }

  async handleClickImport() {
    if (this.pendingImportLabotest) {
      return
    }

    try {
      this.pendingImportLabotest = true
      this.errorMessage = ''
      const data = this.sessionData

      await this.$store.dispatch('labotest/create', { data })

      this.$store.commit('user/setSessionData', {
        labotestStoredCount: this.labotests.length
      })

      this.isSuccessCreate = true
      this.$router.push({ name: 'LabotestImportComplete' })
    } catch (error) {
      this.errorMessage = '保存できませんでした。'
    } finally {
      this.pendingImportLabotest = false
    }
  }

  async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (allow?: boolean) => void
  ) {
    if (from.name !== 'ManagePatient') {
      next(false)
      return
    }
    if (typeof store.getters['user/sessionData']('labotest') !== 'string') {
      next(false)
      return
    }
    next()
  }

  beforeRouteLeave(to: Route, from: Route, next: (allow?: boolean) => void) {
    if (!this.isSuccessCreate) {
      this.$store.commit('user/setSessionData', { labotest: null })
    }
    next()
  }
}
